export default __webpack_public_path__ + "static/media/asset-10.6f01d592.webp";